import { Navigation, Pagination, Swiper } from 'swiper';

export default class Block09 {
    constructor (query) {
        const elems = document.querySelectorAll(query);
        if (!elems || !elems.length) return;

        this.query = query;
        this.elems = [...elems];

        this.init();
    }

    init () {
        this.setupSlider();
    }

    setupSlider () {
        this.elems.forEach((elem) => {
            const slider = elem.querySelector(`${this.query}__slider`);
            if (!slider) return;

            new Swiper(slider, {
                modules: [Navigation, Pagination],
                spaceBetween: 40,
                speed: 600,
                navigation: {
                    prevEl: elem.querySelector(`${this.query}__slider--button-prev`),
                    nextEl: elem.querySelector(`${this.query}__slider--button-next`)
                },
                pagination: {
                    el: elem.querySelector(`${this.query}__slider--pagination`),
                    clickable: true,
                    renderBullet: (index, className) => {
                        const number = index < 10 ? `0${index + 1}` : index + 1;

                        return `<span class="${className}">${number}</span>`;
                    }
                }
            });
        });
    }
}
